// extracted by mini-css-extract-plugin
module.exports = {"SM":"360px","MD":"640px","LG":"1200px","Root":"Footer_Root__MHOkX","Container":"Footer_Container__6Jku2","Item":"Footer_Item__3UUb_"};